import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import { RichText } from 'prismic-reactjs';
import React from 'react';
import Link from '../../Link/Link';

const TestimonialSlice = (props: TestimonialSliceType) => {
  const { slice } = props;
  return (
    <Flex
      flexDir='column'
      gridGap='32px'
      pb={{ base: '60px', md: '120px' }}
      borderBottom='1px solid'
      borderBottomColor='aliceblue.200'
    >
      <Heading size='h2' as='h2' fontWeight='700'>
        {slice.primary.testimonial_title}
      </Heading>
      {slice.items.map((item, index) => (
        <Flex
          key={index}
          gridGap={{ base: '24px', lg: '60px' }}
          justify='space-between'
          p='24px'
          bg='aliceblue.0'
          border='1px solid'
          borderColor='aliceblue.200'
          borderRadius='4px'
          flexDir={{ base: 'column', lg: 'row' }}
        >
          <Box w='100%' maxW='150px'>
            <Image
              src={item.company_icon.url}
              alt={item.company_icon.alt}
              w='100%'
            />
          </Box>
          <Flex gridGap='12px' maxW='874' w='100%'>
            <Box maxW='24px' w='100%'>
              <Image
                src={item.quotes_icon.url}
                alt={item.quotes_icon.alt}
                w='100%'
              />
            </Box>
            <Flex flexDir='column' gridGap='20px' align='flex-start'>
              <Text fontWeight='400' fontSize='18px' textAlign='start'>
                {item.testimonial_card_body}
              </Text>
              <Flex gridGap='12px'>
                <Text  pt='2px' fontWeight={600}>&#8212;</Text>
                <Text> {RichText.render(item.author.richText)}</Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      ))}
      <PrismicRichText
        field={slice.primary.testimonial_footer_text.richText}
        components={{
          paragraph: ({ children }) => (
            <Text fontSize='18px' fontWeight='400'>
              {children}
            </Text>
          ),
          hyperlink: ({ node, children }) => (
            <Link blue to={node.data.url} fontWeight='500'>
              <Flex color='pdftron' _hover={{ color: 'blue.500' }}>
                {children}
              </Flex>
            </Link>
          ),
        }}
      />
    </Flex>
  );
};

export type TestimonialSliceType = SliceComponentProps<{
  id: string;
  items: {
    author: {
      richText: any;
    };
    company_icon: {
      url: string;
      alt: string;
    };
    quotes_icon: {
      url: string;
      alt: string;
    };
    testimonial_card_body: string;
  }[];
  primary: {
    testimonial_footer_text: {
      richText: any;
    };
    testimonial_title: string;
  };
  slice_type: string;
}>;

export default TestimonialSlice;
